//TO MAKE TEST GO TO COLLECTION WEB PAGE, BECOSE THE COLLECTION IS IN SESSION VAR
//run function read size-Directory.js

// To hidde the Measure twice
$( document ).ready(function() {
    // Disable #x
   
 // $("#tagMeasure").hide();

  setTimeout(function(){
      $("#tagMeasure").show();
  }, 2000);

});


//SELECT AUTOMATIC DROPDOWN
function changeStyle(){
  var productName= $("#productName").val();
    if(productName.match('Heirloom Classic')){
       $("#idTypeMB").val("1").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Hierloom Luxe')){
       $("#idTypeMB").val("2").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Kickers')){
       $("#idTypeMB").val("3").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Chitos')){
       $("#idTypeMB").val("4").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Livingston')){
       $("#idTypeMB").val("5").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Mojave')){
       $("#idTypeMB").val("6").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Mary Janes')){
       $("#idTypeMB").val("7").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Oxfords')){
       $("#idTypeMB").val("8").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Chelsea Hawks')){
       $("#idTypeMB").val("9").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Oliver')){
       $("#idTypeMB").val("10").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Engineer')){
       $("#idTypeMB").val("11").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Explorer')){
       $("#idTypeMB").val("12").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Bloom')){
       $("#idTypeMB").val("13").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Ranchos')){
       $("#idTypeMB").val("14").change();
       $("#idTypeMB").prop( "disabled", true );
    }else if(productName.match('Camperas')){
       $("#idTypeMB").val("15").change();
       $("#idTypeMB").prop( "disabled", true );
    }
}


//TO CHANGE DROPDOWN
function selectSize(){
  var collectionTitle = $("#collectionTitle").val();
  var collectiontype = $("#collectionType").val();
  var idTypeSize;
  var idTypeSize;
  
 console.log(collectiontype);
  //if(collectionTitle.match(/Kid/) || collectiontype == "kid"){
  if(collectiontype.match(/Kid/)){
   	  idTypeSize="1"; console.log("entraste");
      document.getElementById("two").hidden=true; //DISABLED VALUES
  	  document.getElementById("three").hidden=true;
      document.getElementById("four").hidden=true;
  }
  
   //if(collectionTitle.match(/Women/ || collectiontype == "Women")){
	if(collectiontype == "Women"){
      console.log("entraste");
   	  idTypeSize="2";
      document.getElementById("one").hidden=true;
  	  document.getElementById("three").hidden=true;
      document.getElementById("four").hidden=true;
      document.getElementById("five").hidden=true;
  }
  
  //if(collectionTitle.match(/Men/) || collectiontype == "Men"){
  if(collectiontype == "Men"){
   	  idTypeSize="3";
      document.getElementById("one").hidden=true;
  	  document.getElementById("two").hidden=true;
      document.getElementById("four").hidden=true;
     document.getElementById("five").hidden=true;
  }
  
   //if(collectionTitle.match(/Baby/) || collectiontype == "Baby"){
  if(collectiontype == "Baby"){
   	  idTypeSize="4";
      document.getElementById("one").hidden=true;
  	  document.getElementById("two").hidden=true;
      document.getElementById("three").hidden=true;
      document.getElementById("five").hidden=true;
  }
  
  
  //ASIGN VALUE
  $("#idType").val(idTypeSize).change();

}

  
//function to read size-Directory.js  
//when dropdown change call this function
function getInchSize() {

  var idSize;
  var type = $("#idType").val();
  var sizeId = $("#size").val();
  setTimeout(changeButtonTxt,50);
 
  	if(sizeId == ''){
      $("#showYourSize").html("0"); 
  	}
    if(sizeId == "4.5/5" && type == "1"){
      $("#showYourSize").html("4.5/5"); 
      $("#SingleOptionSelector-0").val("4.5-5 US").change();
    }else{
    if(sizeId == "5.5" && type == "1"){
      $("#showYourSize").html("5.5");
      $("#SingleOptionSelector-0").val("5.5 US").change();
    }else{
    if(sizeId == "6/6.5" && type == "1"){
      $("#showYourSize").html("6/6.5");
      $("#SingleOptionSelector-0").val("6-6.5 US").change();
    }else{
    if(sizeId == "7/7.5" && type == "1"){
      $("#showYourSize").html("7/7.5");
      $("#SingleOptionSelector-0").val("7-7.5 US").change();
    }else{
    if(sizeId == "8" && type == "1"){
      $("#showYourSize").html("8");
      $("#SingleOptionSelector-0").val("8 US").change();
    }else{
    if(sizeId == "8.5/9" && type == "1"){
      $("#showYourSize").html("8.5/9");
      $("#SingleOptionSelector-0").val("8.5-9 US").change();
    }else{
    if(sizeId == "9.5" && type == "1"){
      $("#showYourSize").html("9.5");
      $("#SingleOptionSelector-0").val("9.5 US").change();
    }else{
    if(sizeId == "10/10.5" && type == "1"){
      $("#showYourSize").html("10/10.5");
      $("#SingleOptionSelector-0").val("10-10.5 US").change();
    }else{
    if(sizeId == "11" && type == "1"){
      $("#showYourSize").html("11");
      $("#SingleOptionSelector-0").val("11 US").change();
    }else{
    if(sizeId == "11.5" && type == "1"){
      $("#showYourSize").html("11.5");
      $("#SingleOptionSelector-0").val("11.5 US").change();
    }else{
    if(sizeId == "12/12.5" && type == "1"){
      $("#showYourSize").html("12/12.5");
      $("#SingleOptionSelector-0").val("12-12.5 US").change();
    }else{
   	if(sizeId == "13/13.5" && type == "1"){
      $("#showYourSize").html("13/13.5");
      $("#SingleOptionSelector-0").val("13-13.5 US").change();
    }else{
    if(sizeId == "6" && type == "2"){
      $("#showYourSize").html("6");
      $("#SingleOptionSelector-0").val("6 US").change();
    }else{
    if(sizeId == "7" && type == "2"){
      $("#showYourSize").html("7");
      $("#SingleOptionSelector-0").val("7 US").change();
    }else{
    if(sizeId == "8" && type == "2"){
      $("#showYourSize").html("8");
      $("#SingleOptionSelector-0").val("8 US").change();
    }else{
    if(sizeId == "9" && type == "2"){
      $("#showYourSize").html("9");
      $("#SingleOptionSelector-0").val("9 US").change();
    }else{
    if(sizeId == "10" && type == "2"){
      $("#showYourSize").html("10");
      $("#SingleOptionSelector-0").val("10 US").change();
    }else{
    if(sizeId == "11" && type == "2"){
      $("#showYourSize").html("11");
      $("#SingleOptionSelector-0").val("11 US").change();
    }else{
    if(sizeId == "12" && type == "2"){
      $("#showYourSize").html("12");
      $("#SingleOptionSelector-0").val("12 US").change();
    }else{
    if(sizeId == "8" && type == "3"){
      $("#showYourSize").html("8");
      $("#SingleOptionSelector-0").val("8 US").change();
    }else{
    if(sizeId == "9" && type == "3"){
      $("#showYourSize").html("9");
      $("#SingleOptionSelector-0").val("9 US").change();
    }else{
    if(sizeId == "10" && type == "3"){
      $("#showYourSize").html("10");
      $("#SingleOptionSelector-0").val("10 US").change();
    }else{
    if(sizeId == "11" && type == "3"){
      $("#showYourSize").html("11");
      $("#SingleOptionSelector-0").val("11 US").change();
    }else{
    if(sizeId == "12" && type == "3"){
      $("#showYourSize").html("12");
      $("#SingleOptionSelector-0").val("12 US").change();
    }else{
    if(sizeId == "13" && type == "3"){
      $("#showYourSize").html("13");
      $("#SingleOptionSelector-0").val("13 US").change();
    }else{
    if(sizeId == "3-6M" && type == "4"){
      $("#showYourSize").html("3-6M");
      $("#SingleOptionSelector-0").val('3-6M - 4\" to 4\"-1\/8\"').change();
    }else{
    if(sizeId == "6-9M" && type == "4"){
      $("#showYourSize").html("6-9M");
      $("#SingleOptionSelector-0").val('6-9M - 4\"-1\/4\" to 4\"-3\/8\"').change();
    }else{
    if(sizeId == "9-12M" && type == "4"){
      $("#showYourSize").html("9-12M");
      $("#SingleOptionSelector-0").val('9-12M - 4\"-1\/2\" to 4\"-5\/8\"').change();
    }else{
    if(sizeId == "1" && type == "5"){
      $("#showYourSize").html("1");
      $("#SingleOptionSelector-0").val("1 US").change();
    }else{
    if(sizeId == "1.5/2" && type == "5"){
      $("#showYourSize").html("1.5/2");
      $("#SingleOptionSelector-0").val("1.5-2 US").change();
    }else{
    if(sizeId == "2.5/3" && type == "5"){
      $("#showYourSize").html("2.5/3");
      $("#SingleOptionSelector-0").val("2.5-3 US").change();
    }else{
    if(sizeId == "3.5/4" && type == "5"){
      $("#showYourSize").html("3.5/4");
      $("#SingleOptionSelector-0").val("3.5-4 US").change();
    }
    }}}}}}}}}}}}}}}}}}}}}}}}}}}}}}}
   

}
///Measurre twice
function getInchSizeM() {

  var idSize;
  var type = $("#idTypeM").val();
  var sizeId = $("#sizeM").val();
  setTimeout(changeButtonTxt,50);
 
  	if(sizeId == ''){
      $("#showYourSize").html("0"); 
  	}else if(sizeId == "1" && type == "1"){
      $("#showYourSize").html("3.5/4"); 
    }else if(sizeId == "2" && type == "1"){
      $("#showYourSize").html("2.5/3");
    }else if(sizeId == "3" && type == "1"){
      $("#showYourSize").html("1.5/2");
    }else if(sizeId == "4" && type == "1"){
      $("#showYourSize").html("1");
    }else if(sizeId == "5" && type == "1"){
      $("#showYourSize").html("13/13.5");
    }else if(sizeId == "6" && type == "1"){
      $("#showYourSize").html("12/12.5");
    }else if(sizeId == "7" && type == "1"){
      $("#showYourSize").html("11.5");
    }else if(sizeId == "8" && type == "1"){
      $("#showYourSize").html("11");
    }else if(sizeId == "9" && type == "1"){
      $("#showYourSize").html("10/10.5");
    }else if(sizeId == "10" && type == "1"){
      $("#showYourSize").html("9.5");
    }else if(sizeId == "11" && type == "1"){
      $("#showYourSize").html("8.5/9");
    }else if(sizeId == "12" && type == "1"){
      $("#showYourSize").html("8");
    }else if(sizeId == "13" && type == "1"){
      $("#showYourSize").html("7/7.5");
    }else if(sizeId == "14" && type == "1"){
      $("#showYourSize").html("6/6.5");
    }else if(sizeId == "15" && type == "1"){
      $("#showYourSize").html("5.5");
    }else if(sizeId == "16" && type == "1"){
      $("#showYourSize").html("4.5/5");
    }else if(sizeId == "1" && type == "2"){
      $("#showYourSize").html("2.5/3");
    }else if(sizeId == "2" && type == "2"){
      $("#showYourSize").html("1.5/2");
    }else if(sizeId == "3" && type == "2"){
      $("#showYourSize").html("1");
    }else if(sizeId == "4" && type == "2"){
      $("#showYourSize").html("13/13.5");
    }else if(sizeId == "5" && type == "2"){
      $("#showYourSize").html("12/12.5");
    }else if(sizeId == "6" && type == "2"){
      $("#showYourSize").html("11.5");
    }else if(sizeId == "7" && type == "2"){
      $("#showYourSize").html("11");
    }else if(sizeId == "8" && type == "2"){
      $("#showYourSize").html("10/10.5");
    }else if(sizeId == "9" && type == "2"){
      $("#showYourSize").html("9.5");
    }else if(sizeId == "10" && type == "2"){
      $("#showYourSize").html("8.5/9");
    }else if(sizeId == "11" && type == "2"){
      $("#showYourSize").html("8");
    }else if(sizeId == "12" && type == "2"){
      $("#showYourSize").html("7/7.5");
    }else if(sizeId == "13" && type == "2"){
      $("#showYourSize").html("6/6.5");
    }else if(sizeId == "14" && type == "2"){
      $("#showYourSize").html("5.5");
    }else if(sizeId == "15" && type == "2"){
      $("#showYourSize").html("4.5/5");
    }
}

///*********************Buy Measure Twice*****/
function getInchSizeMB() {

  var idSize;
  var type = $("#idTypeMB").val();
  var sizeId = $("#sizeMB").val();
  setTimeout(changeButtonTxt,50);
 
  	if(sizeId == ''){
      $("#showYourSize").html("0"); 
  	}else if(sizeId == "1" && type <= 5){
      $("#showYourSize").html("3.5/4"); 
      $("#SingleOptionSelector-0").val("3.5-4 US").change();
    }else if(sizeId == "2" && type <= 5){
      $("#showYourSize").html("2.5/3");
      $("#SingleOptionSelector-0").val("2.5-3 US").change();
    }else if(sizeId == "3" && type <= 5){
      $("#showYourSize").html("1.5/2");
      $("#SingleOptionSelector-0").val("1.5-2 US").change();
    }else if(sizeId == "4" && type <= 5){
      $("#showYourSize").html("1");
      $("#SingleOptionSelector-0").val("1 US").change();
    }else if(sizeId == "5" && type <= 5){
      $("#showYourSize").html("13/13.5");
      $("#SingleOptionSelector-0").val("13-13.5 US").change();
    }else if(sizeId == "6"&& type <= 5){
      $("#showYourSize").html("12/12.5");
      $("#SingleOptionSelector-0").val("12-12.5 US").change();
    }else if(sizeId == "7" && type <= 5){
      $("#showYourSize").html("11.5");
      $("#SingleOptionSelector-0").val("11.5 US").change();
    }else if(sizeId == "8" && type <= 5){
      $("#showYourSize").html("11");
      $("#SingleOptionSelector-0").val("11 US").change();
    }else if(sizeId == "9" && type <= 5){
      $("#showYourSize").html("10/10.5");
      $("#SingleOptionSelector-0").val("10-10.5 US").change();
    }else if(sizeId == "10" && type <= 5){
      $("#showYourSize").html("9.5");
      $("#SingleOptionSelector-0").val("3.5 US").change();
    }else if(sizeId == "11" && type <= 5){
      $("#showYourSize").html("8.5/9");
      $("#SingleOptionSelector-0").val("8.5-9 US").change();
    }else if(sizeId == "12" && type <= 5){
      $("#showYourSize").html("8");
      $("#SingleOptionSelector-0").val("8 US").change();
    }else if(sizeId == "13" && type <= 5){
      $("#showYourSize").html("7/7.5");
      $("#SingleOptionSelector-0").val("7-7.5 US").change();
    }else if(sizeId == "14" && type <= 5){
      $("#showYourSize").html("6/6.5");
      $("#SingleOptionSelector-0").val("6-6.5 US").change();
    }else if(sizeId == "15" && type <= 5){
      $("#showYourSize").html("5.5");
      $("#SingleOptionSelector-0").val("5.5 US").change();
    }else if(sizeId == "16" && type <= 5){
      $("#showYourSize").html("4.5/5");
      $("#SingleOptionSelector-0").val("4.5-5 US").change();
    }else if(sizeId == "1" && type > 5){
      $("#showYourSize").html("2.5/3");
      $("#SingleOptionSelector-0").val("2.5-3 US").change();
    }else if(sizeId == "2" && type > 5){
      $("#showYourSize").html("1.5/2");
      $("#SingleOptionSelector-0").val("1.5-2 US").change();
    }else if(sizeId == "3" && type > 5){
      $("#showYourSize").html("1");
      $("#SingleOptionSelector-0").val("1 US").change();
    }else if(sizeId == "4" && type > 5){
      $("#showYourSize").html("13/13.5");
      $("#SingleOptionSelector-0").val("13-13.5 US").change();
    }else if(sizeId == "5" && type > 5){
      $("#showYourSize").html("12/12.5");
      $("#SingleOptionSelector-0").val("12-12.5 US").change();
    }else if(sizeId == "6" && type > 5){
      $("#showYourSize").html("11.5");
      $("#SingleOptionSelector-0").val("11.5 US").change();
    }else if(sizeId == "7" && type > 5){
      $("#showYourSize").html("11");
      $("#SingleOptionSelector-0").val("11 US").change();
    }else if(sizeId == "8" && type > 5){
      $("#showYourSize").html("10/10.5");
      $("#SingleOptionSelector-0").val("10-10.5 US").change();
    }else if(sizeId == "9" && type > 5){
      $("#showYourSize").html("9.5");
      $("#SingleOptionSelector-0").val("9.5 US").change();
    }else if(sizeId == "10" && type > 5){
      $("#showYourSize").html("8.5/9");
      $("#SingleOptionSelector-0").val("8.5-9 US").change();
    }else if(sizeId == "11" && type > 5){
      $("#showYourSize").html("8");
      $("#SingleOptionSelector-0").val("8 US").change();
    }else if(sizeId == "12" && type > 5){
      $("#showYourSize").html("7/7.5");
      $("#SingleOptionSelector-0").val("7-7.5 US").change();
    }else if(sizeId == "13" && type > 5){
      $("#showYourSize").html("6/6.5");
      $("#SingleOptionSelector-0").val("6-6.5 US").change();
    }else if(sizeId == "14" && type > 5){
      $("#showYourSize").html("5.5");
      $("#SingleOptionSelector-0").val("5.5 US").change();
    }else if(sizeId == "15" && type > 5){
      $("#showYourSize").html("4.5/5");
      $("#SingleOptionSelector-0").val("4.5-5 US").change();
    }
}
function changeButtonTxt(){
    var btnTxt=$("#buttonTXT").text();
    $("#buttonTXTM").html($("#buttonTXT").text());

    if(btnTxt =="Sold Out" || btnTxt =="Preview"){
      document.getElementById("add").disabled=true;
      document.getElementById("addM").disabled=true;
      document.getElementById("BIS_triggerM").hidden=false;
    }else{
      document.getElementById("add").disabled=false;
      document.getElementById("addM").disabled=false;
      document.getElementById("BIS_triggerM").hidden=true;
    }
}



function resetCero(){
	$("#showYourSize").html("0");
}
  

//when press button No
function closeConfirm(){
   alertify.confirm().destroy(); 
   location.reload(true);
  
}


//when press button No
function closeConfirmMeasure(){
   alertify.confirm().destroy(); 
}
  
//when press button Yes  
function sizeConfirm()
{
  alertify.confirm().destroy(); 
  var pagebutton= document.getElementById("addHidden");
  pagebutton.click();
}
  
var coustomSizeChar;
//show alert to confirm size 
function showModal(){
  coustomSizeChar = $("#coustomsSizeChar").val();

  alertify.confirm('<button type="button" style="top:0; margin-left:95%; background-color:white" onclick="closeConfirm()">x</button>'+
        				'<div style="padding:10px; ">'+
                                  '<table>'+
                                  '<tr><td></td><td> • Our customers report our shoes run true to size.</td><tr></tr>'+
                                  '<tr><td></td><td> • Our sizes can be different than other brands. Do not size up.</td><tr></tr>'+
                                  '<tr><td></td><td> • Shoes already include room to grow and for socks.</td><tr></tr>'+
                                  '<tr><td></td><td> • Always use our easy printable <b onclick="goShizeChart()" style="cursor:pointer; text-decoration: underline;">"Size Chart"</b> to find the right fit after you have measured.</td><tr></tr>'+
                                  '<table>'+
                                  '</div><br><br>'+
                                  '<div id="btn-yes" style="text-align:center; padding-left:20px; padding-right:20px; ">'+
                                    '<button type="button" id="b1" onclick="showMeasureBuy()" style="background-color: black; color: white" ><p><b>NO</b> I did not use the Size Chart - I need help please</p></button><br><br>'+
                                    '<button type="button" id="b1" onclick="sizeConfirm()" style="color:black" ><p><b>YES</b> I measured and used the Size Chart - please add this size</p></button>'+
                                  '</div>'+
                         '<div style="text-align:center; padding:20px; width:100%; border-radius: 25px;">', 'Confirm Message').set('closable', false); 
  $(".ajs-primary").hide();
  $(".ajs-header").hide();
  $(".ajs-footer").hide();
}



//SHOW DATA IN MODAL
function showForm(){

	$("#btn-yes").html(
    "<div style='text-align:left'>"+
    '<div style="text-align: center;"><iframe width="100%" height="315" src="https://www.youtube.com/embed/Hk0szDz1e34" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div><br>'+
      '<label style="margin-top: -20px; !important">Select Options Below</label><br><br>'+ 
         "<label for='exampleFormControlSelect1'>Collection:</label>"+
          "</div>"+
          '<select id="idType" class="select-css"   style="text-align:center; width:100%; margin-top:-1px"  onchange="dropDownContent(), resetCero()">'+
              "<option value='1' id='one'>KID'S SHOES</option>"+
              "<option value='2' id='two'>WOMEN'S SHOES</option>"+
              "<option value='3' id='three'>MEN'S SHOES</option>"+
              "<option value='4' id='four'>BABY'S SHOES</option>"+
              "<option value='5' id='five'>US-YOUTH SIZES</option>"+
          '<select>'+
          '<br>'+
      "<div class='form-group' style='margin-top:-20px'>"+
          "<div style='text-align:left'>"+
          	"<label for='exampleFormControlSelect1'>MEASUREMENT:</label>"+
          "</div>"+
              "<div id='selectOption'></div>"+
          "</div>"+

          '<label style="margin-top: -20px; !important">This is your size:</label>'+
           '<h1 id="showYourSize" style="margin-top: -10px; !important">0</h1><br>'+
          '<button type="button" name="add" id="addM" class="Button Button--primary" data-add-to-cart="" onClick="sizeConfirm()" style="margin-top: -20px; !important" >'+ 
            '<span id="buttonTXTM" data-add-to-cart-text="" >Buy Now</span>'+
          '</button><br>'+
       '<div id="BIS_triggerM" hidden>'+
       '<button href="#" id="BIS_trigger" class="Button Button--primary" style=" margin-top: 15px;">EMAIL WHEN AVAILABLE</button>'+
        '</div>'+
          '<br>'+
     '</div>'
    );
     selectSize();
     dropDownContent();
}


//SHOW DATA DROWPDOWN CONTENT
function dropDownContent(){
  var type = $("#idType").val();
  console.log("aaa");
  console.log(type);
  console.log("solu:", coustomSizeChar );
  if(type == 1){
    if(coustomSizeChar.match(/kids - 2/)){
       $("#selectOption").html(
        "<select class='select-css' id='size'  style='text-align:center; width:100%; margin-top:-1px'  onchange='getInchSize()'>"+
                "<option value=''>SELECT YOUR MEASUREMENT</option>"+
                 '<option value="4.5/5" >5-1/8" up to 5-1/4"</option>'+
                 '<option value="5.5" >5-3/8" up to 5.5"</option>'+
                 '<option value="6/6.5" >5-5/8" up to 5-7/8"</option>'+
                 '<option value="7/7.5" >5-7/8" up 6"</option>'+
                 '<option value="8">6-1/8" up to 6-1/4"</option>'+
                 '<option value="8.5/9" >6-3/8" up to 6.5"</option>'+
                 '<option value="9.5" >6-5/8" up to 6-3/4"</option>'+
                 '<option value="10/10.5" >6-7/8" up to 7"</option>'+
                 '<option value="11" >7-1/8" up to 7-1/4"</option>'+
                 '<option value="11.5" >7-3/8" up to 7.5"</option>'+
                 '<option value="12/12.5" >7-5/8" up to 7-3/4"</option>'+
                 '<option value="13/13.5" >7-7/8" up to 8"</option>'+
        "</select>"
   );
    }else{
       $("#selectOption").html(
        "<select class='select-css' id='size'  style='text-align:center; width:100%; margin-top:-1px'  onchange='getInchSize()'>"+
                "<option value=''>SELECT YOUR MEASUREMENT</option>"+
                 '<option value="4.5/5" >5" up to 5-1/8"</option>'+
                 '<option value="5.5" >5-1/4" up to 5-3/8"</option>'+
                 '<option value="6/6.5" >5-1/2" up to 5-5/8"</option>'+
                 '<option value="7/7.5" >5-5/8" up to 5-7/8"</option>'+
                 '<option value="8">6" up to 6-1/8"</option>'+
                 '<option value="8.5/9" >6-1/4" up to 6-3/8"</option>'+
                 '<option value="9.5" >6-1/2" up to 6-5/8"</option>'+
                 '<option value="10/10.5" >6-3/4" up to 6-7/8"</option>'+
                 '<option value="11" >7" up to 7-1/8"</option>'+
                 '<option value="11.5" >7-1.4" up to 7-3/8"</option>'+
                 '<option value="12/12.5" >7-1/2" up to 7-5/8"</option>'+
                 '<option value="13/13.5" >7-3/4" up to 7-7/8"</option>'+
        "</select>"
   );
    
    }
    

  }
  
    if(type == 2){
  
     $("#selectOption").html(
       "<select class='select-css' id='size' style='text-align:center; width:100%; margin-top:-1px'     onchange='getInchSize()'>"+
                "<option value=''>SELECT YOUR MEASUREMENT</option>"+
                 '<option value="6">9-1/4" up to 9-3/8"</option>'+
                 '<option value="7">9-1/2" up to 9-5/8"</option>'+
                 '<option value="8">9-3/4 up to 9-7/8"</option>'+
                 '<option value="9">10" up to 10-1/8"</option>'+
                 '<option value="10" >10-1/4" up to 10-3/8"</option>'+
                 '<option value="11" >10-1/2" up to 10-5/8"</option>'+
                 '<option value="12" >10-3/4" up to 10-7/8"</option>'+
        "</select>"
   );

  }
  
  
  if(type == 3){
  
     $("#selectOption").html(
        "<select class='select-css' id='size'  style='text-align:center; width:100%; margin-top:-1px'  onchange='getInchSize()'>"+
                "<option value=''>SELECT YOUR MEASUREMENT</option>"+
                 '<option value="8">10-1/2" up to 10-5/8"</option>'+
                 '<option value="9">10-3/4" up to 10-7/8"</option>'+
                 '<option value="10">11" up to 11-1/8"</option>'+
                 '<option value="11">11-1/4" up to 11-3/8"</option>'+
                 '<option value="12" >11-1/2" up to 11-5/8"</option>'+
                 '<option value="13" >11-3/4" up to 11-7/8"</option>'+
        "</select>"
   );

  }
  
  if(type == 4){
  
     $("#selectOption").html(
        "<select class='select-css' id='size'  style='text-align:center; width:100%; margin-top:-1px'  onchange='getInchSize()'>"+
                "<option value=''>SELECT YOUR MEASUREMENT</option>"+
                 '<option value="3-6M">4" up to 4"-1/8"</option>'+
                 '<option value="6-9M">4"-1/4" up to 4"-3/8"</option>'+
                 '<option value="9-12M">4"-1/2" up to 4"-5/8"</option>'+
        "</select>"
   );

  }
  
  if(type == 5){
          if(coustomSizeChar.match(/kids - 2/)){
                 $("#selectOption").html(
              "<select class='form-control' id='size'  style='text-align:center; width:100%; margin-top:-1px'  onchange='getInchSize()'>"+
                      "<option value=''>SELECT YOUR MEASUREMENT</option>"+
                       '<option value="1">8-1/8" up to 8-1/4"</option>'+
                       '<option value="1.5/2">8-3/8" up to 8.5"</option>'+
                       '<option value="2.5/3">8-5/8" up to 8-3/4"</option>'+
              "</select>"
         );
          }
          else{
            $("#selectOption").html(
              "<select class='form-control' id='size'  style='text-align:center; width:100%; margin-top:-1px'  onchange='getInchSize()'>"+
                      "<option value=''>SELECT YOUR MEASUREMENT</option>"+
                       '<option value="1">8" up to 8-1/8"</option>'+
                       '<option value="1.5/2">8-1/4" up to 8-3/8"</option>'+
                       '<option value="2.5/3">8-1/2" up to 8-5/8"</option>'+
                       '<option value="3.5/4">8-3/4" up to 8-7/8"</option>'+
              "</select>"
         );
    
 }
    
    
  	
  
  }
  
}

function goShizeChart(){
   window.open("https://www.mikoleon.com/pages/new-printable-size-chart", '_blank');
   alertify.confirm().destroy(); 
  document.getElementById("btnSize2").click();
}


//Measure twice
function showMeasure(){
  coustomSizeChar = $("#coustomsSizeChar").val();
/*
  alertify.confirm('<button type="button" style="top:0; margin-left:95%; background-color:white" onclick="closeConfirmMeasure()">x</button>'+
        				'<div style="padding:10px; ">'+
                                     '<div style="text-align:center">'+
                                    '<h3>Measure Twice, Pay Once</h3><br>'+
                                     '</div>'+
                                   "Please note that we no longer offer a free size exchange for children's boots (only for adults); you must measure before you buy or you will need to pay for the size exchange return label.<br><br>"+
                                  '<table>'+
                                  '<tr><td></td><td> • Our customers report our shoes run true to size.</td><tr></tr>'+
                                  '<tr><td></td><td> • Our sizes can be different than other brands. Do not size up.</td><tr></tr>'+
                                  '<tr><td></td><td> • Shoes already include room to grow and for socks.</td><tr></tr>'+
                                  '<tr><td></td><td> • Always use our easy printable <b onclick="goShizeChart()" style="cursor:pointer; text-decoration: underline;">"Size Chart"</b> to find the right fit after you have measured.</td><tr></tr>'+
                                  '<table>'+
                                  '</div><br><br>'+
                                  '<div id="btn-yes" style="text-align:center; padding-left:20px; padding-right:20px; ">'+
                                        "<div style='text-align:left'>"+
                                  '<div style="text-align: center !important;"><iframe width="100%" height="315" src="https://www.youtube.com/embed/Hk0szDz1e34" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div><br>'+
                                    '<label style="margin-top: -20px; !important">Select Options Below</label><br><br>'+ 
                                         "<label for='exampleFormControlSelect1'>Style:</label>"+
                                        "</div>"+
                                        '<select id="idTypeM" class="select-css"   style="text-align:center; width:100%; margin-top:-1px"  onchange="dropDownContentMeasure(), resetCero()">'+
                                           "<option value='0' id='cero'>Select Style</option>"+ 
                                           "<option value='1' id='one'>Heirlooms Classic</option>"+
                                            "<option value='1' id='two'>Heirlooms Luxe</option>"+
                                            "<option value='1' id='three'>Kickers</option>"+
                                            "<option value='1' id='four'>Chitos</option>"+
                                            "<option value='1' id='five'>Livingston</option>"+
                                             "<option value='2' id='six'>Mojave</option>"+
                                            "<option value='2' id='seven'>Mary Janes</option>"+
                                            "<option value='2' id='eight'>Oxfords</option>"+
                                            "<option value='2' id='nine'>Chelsea Hawks</option>"+
                                             "<option value='2' id='ten'>Oliver</option>"+
                                             "<option value='2' id='eleven'>Engineer</option>"+
                                             "<option value='2' id='twelve'>Explorer</option>"+
                                             "<option value='2' id='twelvee'>Bloom</option>"+
                                            "<option value='2' id='thirteen'>Camperas</option>"+
                                             "<option value='2' id='fourteen'>Ranchos</option>"+
                                        '<select>'+
                                        '<br>'+      
                                    "<div class='form-group' style='margin-top:-20px'>"+
                                        "<div style='text-align:left'>"+
                                        	"<label for='exampleFormControlSelect1'>Foot Length Measurement:</label>"+
                                        "</div>"+
                                            "<div id='selectOption'></div>"+
                                        "</div>"+
                              
                                        '<label style="margin-top: -20px; !important">This is your size:</label>'+
                                         '<h1 id="showYourSize" style="margin-top: -10px; !important">0</h1><br>'+
                                     '<div id="BIS_triggerM" hidden>'+
                                      '</div>'+
                                        '<br>'+
                                   '</div>'+
                                  '</div>'+
                                   '<a href="https://www.mikoleon.com/pages/shoe-size-chart" style="text-decoration:underline black">Adult Size Chart</a><br>'+
                                   '<a href="https://www.mikoleon.com/pages/shoe-size-chart" style="text-decoration:underline black">Baby Size Chart</a>'+
                         '<div style="text-align:center; padding:20px; width:100%; border-radius: 25px;">', 'Confirm Message').set('closable', false); */

   alertify.confirm('<button type="button" style="top:0; margin-left:95%; background-color:white" onclick="closeConfirmMeasure()">x</button>'+
        				'<div style="padding:10px; ">'+
                                     '<div style="text-align:center">'+
                                    '<h3>How to get one Free Size Exchange, easy peasy!</h3><br>'+
                                     '</div>'+
                                   'Use our Sizing Genie to find the perfect fit or your size exchange is free if our Genie suggests the wrong size!<br>'+
                                    'Make sure to follow these steps before you buy:'+
                                  '<table>'+
                                  '<tr><td>&nbsp;<br></td><td></td><tr></tr>'+
                                  '<tr><td></td><td> 1. Of course, you need to measure first using our Printable Size Charts and make sure you are reading your ruler correctly.</td><tr></tr>'+
                                  '<tr><td></td><td> 2. Take a screenshot of the size our Sizing Genie suggests you buy.</td><tr></tr>'+
                                  '<tr><td>&nbsp;<br></td><td></td><tr></tr>'+
                                  "<tr><td></td><td> That's it! No more worrying about the right fit, leave that to us!</td><tr></tr>"+
                                  '<table>'+
                                  '</div><br><br>'+
                                  '<div id="btn-yes" style="text-align:center; padding-left:20px; padding-right:20px; ">'+
                                        "<div style='text-align:left'>"+
                                  '<div style="text-align: center !important;"><iframe width="100%" height="315" src="https://www.youtube.com/embed/Hk0szDz1e34" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div><br>'+
                                    '<label style="margin-top: -20px; !important">Select Options Below</label><br><br>'+ 
                                         "<label for='exampleFormControlSelect1'>Style:</label>"+
                                        "</div>"+
                                        '<select id="idTypeM" class="select-css"   style="text-align:center; width:100%; margin-top:-1px"  onchange="dropDownContentMeasure(), resetCero()">'+
                                           "<option value='0' id='cero'>Select Style</option>"+ 
                                           "<option value='1' id='one'>Heirlooms Classic</option>"+
                                            "<option value='1' id='two'>Heirlooms Luxe</option>"+
                                            "<option value='1' id='three'>Kickers</option>"+
                                            "<option value='1' id='four'>Chitos</option>"+
                                            "<option value='1' id='five'>Livingston</option>"+
                                             "<option value='2' id='six'>Mojave</option>"+
                                            "<option value='2' id='seven'>Mary Janes</option>"+
                                            "<option value='2' id='eight'>Oxfords</option>"+
                                            "<option value='2' id='nine'>Chelsea Hawks</option>"+
                                             "<option value='2' id='ten'>Oliver</option>"+
                                             "<option value='2' id='eleven'>Engineer</option>"+
                                             "<option value='2' id='twelve'>Explorer</option>"+
                                             "<option value='2' id='twelvee'>Bloom</option>"+
                                            "<option value='2' id='thirteen'>Camperas</option>"+
                                             "<option value='2' id='fourteen'>Ranchos</option>"+
                                        '<select>'+
                                        '<br>'+      
                                    "<div class='form-group' style='margin-top:-20px'>"+
                                        "<div style='text-align:left'>"+
                                        	"<label for='exampleFormControlSelect1'>Foot Length Measurement:</label>"+
                                        "</div>"+
                                            "<div id='selectOption'></div>"+
                                        "</div>"+
                              
                                        '<label style="margin-top: -20px; !important">This is your size:</label>'+
                                         '<h1 id="showYourSize" style="margin-top: -10px; !important">0</h1><br>'+
                                     '<div id="BIS_triggerM" hidden>'+
                                      '</div>'+
                                        '<br>'+
                                   '</div>'+
                                  '</div>'+
                                   '<a href="https://www.mikoleon.com/pages/shoe-size-chart" style="text-decoration:underline black">Adult Size Chart</a><br>'+
                                   '<a href="https://www.mikoleon.com/pages/shoe-size-chart" style="text-decoration:underline black">Baby Size Chart</a>'+
                         '<div style="text-align:center; padding:20px; width:100%; border-radius: 25px;">', 'Confirm Message').set('closable', false);
  
  $(".ajs-primary").hide();
  $(".ajs-header").hide();
  $(".ajs-footer").hide();
}

//Measure twice
function dropDownContentMeasure(){
  var type = $("#idTypeM").val();
 
    if(type == 1 && type <= 5){
  
     $("#selectOption").html(
       "<select class='select-css' id='sizeM' style='text-align:center; width:100%; margin-top:-1px'   onchange='getInchSizeM()'>"+
                "<option value=''>Select Your Foot Measurement</option>"+
                 '<option value="1">8-3/4" up to 8-7/8"</option>'+
                 '<option value="2">8.5" up to 8-5/8"</option>'+
                 '<option value="3">8-1/4" up to 8-3/8"</option>'+
                 '<option value="4">8" up to 8-1/8"</option>'+
                 '<option value="5" >7-3/4" up to 7-7/8"</option>'+
                 '<option value="6" >7.5" up to 7-5/8"</option>'+
                 '<option value="7" >7-1/4" up to 7-3/8"</option>'+
                 '<option value="8" >7" up to 7-1/8"</option>'+
                 '<option value="9" >6-3/4" up to 6-7/8"</option>'+
                 '<option value="10" >6.5" up to 6-5/8"</option>'+
                 '<option value="11" >6-1/4" up to 6-3/8"</option>'+
                 '<option value="12" >6" up to 6-1/8"</option>'+
                 '<option value="13" >5-5/8" up to 5-7/8"</option>'+
                 '<option value="14" >5.5" up to 5-5/8"</option>'+
                 '<option value="15" >5-1/4" up to 5-3/8"</option>'+
                 '<option value="16" >5" up to 5-1/8"</option>'+
       "</select>"
   );

  }else{
        $("#selectOption").html(
       "<select class='select-css' id='sizeM' style='text-align:center; width:100%; margin-top:-1px'   onchange='getInchSizeM()'>"+
                "<option value=''>Select Your Foot Measurement</option>"+
                 '<option value="1">8-5/8" up to 8-3/4"</option>'+
                 '<option value="2">8-3/8" up to 8.5"</option>'+
                 '<option value="3">8-1/8" up to 8-1/4"</option>'+
                 '<option value="4">7-7/8" up to 8"</option>'+
                 '<option value="5" >7-5/8" up to 7-3/4"</option>'+
                 '<option value="6" >7-3/8" up to 7.5"</option>'+
                 '<option value="7" >7-1/8" up to 7-1/4"</option>'+
                 '<option value="8" >6-7/8" up to 7"</option>'+
                 '<option value="9" >6-5/8" up to 6-3/4"</option>'+
                 '<option value="10" >6-3/8" up to 6.5"</option>'+
                 '<option value="11" >6-1/8" up to 6-1/4"</option>'+
                 '<option value="12" >5-7/8" up to 6"</option>'+
                 '<option value="13" >5-5/8" up to 5-7/8"</option>'+
                 '<option value="14" >5-3/8" up to 5.5"</option>'+
                 '<option value="15" >5-1/8" up to 5-1/4"</option>'+
       "</select>"
   );
      
  }
  

}


//////*******Buy in product*********///////
//Measure twice
function showMeasureBuy(){
  coustomSizeChar = $("#coustomsSizeChar").val();
/*
  alertify.confirm('<button type="button" style="top:0; margin-left:95%; background-color:white" onclick="closeConfirm()">x</button>'+
        				'<div style="padding:10px; ">'+
                                     '<div style="text-align:center">'+
                                    '<h3>Measure Twice, Pay Once</h3><br>'+
                                     '</div>'+
                                   "Please note that we no longer offer a free size exchange for children's boots (only for adults); you must measure before you buy or you will need to pay for the size exchange return label.<br><br>"+
                                  '<table>'+
                                  '<tr><td></td><td> • Our customers report our shoes run true to size.</td><tr></tr>'+
                                  '<tr><td></td><td> • Our sizes can be different than other brands. Do not size up.</td><tr></tr>'+
                                  '<tr><td></td><td> • Shoes already include room to grow and for socks.</td><tr></tr>'+
                                  '<tr><td></td><td> • Always use our easy printable <b onclick="goShizeChart()" style="cursor:pointer; text-decoration: underline;">"Size Chart"</b> to find the right fit after you have measured.</td><tr></tr>'+
                                  '<table>'+
                                  '</div><br><br>'+
                                  '<div id="btn-yes" style="text-align:center; padding-left:20px; padding-right:20px; ">'+
                                        "<div style='text-align:left'>"+
                                  '<div style="text-align: center !important;"><iframe width="100%" height="315" src="https://www.youtube.com/embed/Hk0szDz1e34" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div><br>'+
                                    '<label style="margin-top: -20px; !important">Select Options Below</label><br><br>'+ 
                                         "<label for='exampleFormControlSelect1'>Style:</label>"+
                                        "</div>"+
                                        '<select id="idTypeMB" class="select-css"   style="text-align:center; width:100%; margin-top:-1px"  onchange="dropDownContentMeasureBuy(), resetCero()">'+
                                           "<option value=0 id='cero'>Select Style</option>"+ 
                                           "<option value=1 id='one'>Heirlooms Classic</option>"+
                                            "<option value=2 id='two'>Heirlooms Luxe</option>"+
                                            "<option value=3 id='three'>Kickers</option>"+
                                            "<option value=4 id='four'>Chitos</option>"+
                                            "<option value=5 id='five'>Livingston</option>"+
                                             "<option value=6 id='six'>Mojave</option>"+
                                            "<option value=7 id='seven'>Mary Janes</option>"+
                                            "<option value=8 id='eight'>Oxfords</option>"+
                                            "<option value=9 id='nine'>Chelsea Hawks</option>"+
                                             "<option value=10 id='ten'>Oliver</option>"+
                                             "<option value=11 id='eleven'>Engineer</option>"+
                                             "<option value=12 id='twelve'>Explorer</option>"+
                                             "<option value=13 id='thirteen'>Bloom</option>"+
                                            "<option value=14 id='fourteen'>Camperas</option>"+
                                             "<option value=15 id='fifteen'>Ranchos</option>"+
                                        '<select>'+
                                        '<br>'+      
                                    "<div class='form-group' style='margin-top:-20px'>"+
                                        "<div style='text-align:left'>"+
                                        	"<label for='exampleFormControlSelect1'>Foot Length Measurement:</label>"+
                                        "</div>"+
                                            "<div id='selectOption'></div>"+
                                        "</div>"+
                              
                                        '<label style="margin-top: -20px; !important">This is your size:</label>'+
                                         '<h1 id="showYourSize" style="margin-top: -10px; !important">0</h1><br>'+
                                     '<div id="BIS_triggerM" hidden>'+
                                      '</div>'+
                                        '<br>'+
          '<button type="button" name="add" id="addM" class="Button Button--primary" data-add-to-cart="" onClick="sizeConfirm()" style="margin-top: -20px; !important" >'+ 
            '<span id="buttonTXTM" data-add-to-cart-text="" >Buy Now</span>'+
          '</button><br>'+
       '<div id="BIS_triggerM" hidden>'+
       '<button href="#" id="BIS_trigger" class="Button Button--primary" style=" margin-top: 15px;">EMAIL WHEN AVAILABLE</button>'+
        '</div>'+
          '<br>'+
                                   '</div>'+
                                  '</div>'+
                                   '<a href="https://www.mikoleon.com/pages/shoe-size-chart" style="text-decoration:underline black">Adult Size Chart</a><br>'+
                                   '<a href="https://www.mikoleon.com/pages/shoe-size-chart" style="text-decoration:underline black">Baby Size Chart</a>'+
                         '<div style="text-align:center; padding:20px; width:100%; border-radius: 25px;">', 'Confirm Message').set('closable', false); */
  
   alertify.confirm('<button type="button" style="top:0; margin-left:95%; background-color:white" onclick="closeConfirm()">x</button>'+
        				'<div style="padding:10px; ">'+
                                      '<div style="text-align:center">'+
                                    '<h3>How to get one Free Size Exchange, easy peasy!</h3><br>'+
                                     '</div>'+
                                   'Use our Sizing Genie to find the perfect fit or your size exchange is free if our Genie suggests the wrong size!<br>'+
                                    'Make sure to follow these steps before you buy:'+
                                  '<table>'+
                                  '<tr><td>&nbsp;<br></td><td></td><tr></tr>'+
                                  '<tr><td></td><td> 1. Of course, you need to measure first using our Printable Size Charts and make sure you are reading your ruler correctly.</td><tr></tr>'+
                                  '<tr><td></td><td> 2. Take a screenshot of the size our Sizing Genie suggests you buy.</td><tr></tr>'+
                                  '<tr><td>&nbsp;<br></td><td></td><tr></tr>'+
                                  "<tr><td></td><td> That's it! No more worrying about the right fit, leave that to us!</td><tr></tr>"+
                                  '<table>'+
                                  '</div><br><br>'+
                                  '<div id="btn-yes" style="text-align:center; padding-left:20px; padding-right:20px; ">'+
                                        "<div style='text-align:left'>"+
                                  '<div style="text-align: center !important;"><iframe width="100%" height="315" src="https://www.youtube.com/embed/Hk0szDz1e34" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div><br>'+
                                    '<label style="margin-top: -20px; !important">Select Options Below</label><br><br>'+ 
                                         "<label for='exampleFormControlSelect1'>Style:</label>"+
                                        "</div>"+
                                        '<select id="idTypeMB" class="select-css"   style="text-align:center; width:100%; margin-top:-1px"  onchange="dropDownContentMeasureBuy(), resetCero()">'+
                                           "<option value=0 id='cero'>Select Style</option>"+ 
                                           "<option value=1 id='one'>Heirlooms Classic</option>"+
                                            "<option value=2 id='two'>Heirlooms Luxe</option>"+
                                            "<option value=3 id='three'>Kickers</option>"+
                                            "<option value=4 id='four'>Chitos</option>"+
                                            "<option value=5 id='five'>Livingston</option>"+
                                             "<option value=6 id='six'>Mojave</option>"+
                                            "<option value=7 id='seven'>Mary Janes</option>"+
                                            "<option value=8 id='eight'>Oxfords</option>"+
                                            "<option value=9 id='nine'>Chelsea Hawks</option>"+
                                             "<option value=10 id='ten'>Oliver</option>"+
                                             "<option value=11 id='eleven'>Engineer</option>"+
                                             "<option value=12 id='twelve'>Explorer</option>"+
                                             "<option value=13 id='thirteen'>Bloom</option>"+
                                            "<option value=14 id='fourteen'>Camperas</option>"+
                                             "<option value=15 id='fifteen'>Ranchos</option>"+
                                        '<select>'+
                                        '<br>'+      
                                    "<div class='form-group' style='margin-top:-20px'>"+
                                        "<div style='text-align:left'>"+
                                        	"<label for='exampleFormControlSelect1'>Foot Length Measurement:</label>"+
                                        "</div>"+
                                            "<div id='selectOption'></div>"+
                                        "</div>"+
                              
                                        '<label style="margin-top: -20px; !important">This is your size:</label>'+
                                         '<h1 id="showYourSize" style="margin-top: -10px; !important">0</h1><br>'+
                                     '<div id="BIS_triggerM" hidden>'+
                                      '</div>'+
                                        '<br>'+
          '<button type="button" name="add" id="addM" class="Button Button--primary" data-add-to-cart="" onClick="sizeConfirm()" style="margin-top: -20px; !important" >'+ 
            '<span id="buttonTXTM" data-add-to-cart-text="" >Buy Now</span>'+
          '</button><br>'+
       '<div id="BIS_triggerM" hidden>'+
       '<button href="#" id="BIS_trigger" class="Button Button--primary" style=" margin-top: 15px;">EMAIL WHEN AVAILABLE</button>'+
        '</div>'+
          '<br>'+
                                   '</div>'+
                                  '</div>'+
                                   '<a href="https://www.mikoleon.com/pages/shoe-size-chart" style="text-decoration:underline black">Adult Size Chart</a><br>'+
                                   '<a href="https://www.mikoleon.com/pages/shoe-size-chart" style="text-decoration:underline black">Baby Size Chart</a>'+
                         '<div style="text-align:center; padding:20px; width:100%; border-radius: 25px;">', 'Confirm Message').set('closable', false);
  $(".ajs-primary").hide();
  $(".ajs-header").hide();
  $(".ajs-footer").hide();
  changeStyle();
}

//Measure twice
function dropDownContentMeasureBuy(){
  var type = $("#idTypeM").val();
 
    if(type == 1 && type <= 5){
  
     $("#selectOption").html(
       "<select class='select-css' id='sizeMB' style='text-align:center; width:100%; margin-top:-1px'   onchange='getInchSizeMB()'>"+
                "<option value=''>Select Your Foot Measurement</option>"+
                 '<option value="1">8-3/4" up to 8-7/8"</option>'+
                 '<option value="2">8.5" up to 8-5/8"</option>'+
                 '<option value="3">8-1/4" up to 8-3/8"</option>'+
                 '<option value="4">8" up to 8-1/8"</option>'+
                 '<option value="5" >7-3/4" up to 7-7/8"</option>'+
                 '<option value="6" >7.5" up to 7-5/8"</option>'+
                 '<option value="7" >7-1/4" up to 7-3/8"</option>'+
                 '<option value="8" >7" up to 7-1/8"</option>'+
                 '<option value="9" >6-3/4" up to 6-7/8"</option>'+
                 '<option value="10" >6.5" up to 6-5/8"</option>'+
                 '<option value="11" >6-1/4" up to 6-3/8"</option>'+
                 '<option value="12" >6" up to 6-1/8"</option>'+
                 '<option value="13" >5-5/8" up to 5-7/8"</option>'+
                 '<option value="14" >5.5" up to 5-5/8"</option>'+
                 '<option value="15" >5-1/4" up to 5-3/8"</option>'+
                 '<option value="16" >5" up to 5-1/8"</option>'+
       "</select>"
   );

  }else{
        $("#selectOption").html(
       "<select class='select-css' id='sizeMB' style='text-align:center; width:100%; margin-top:-1px'   onchange='getInchSizeMB()'>"+
                "<option value=''>Select Your Foot Measurement</option>"+
                 '<option value="1">8-5/8" up to 8-3/4"</option>'+
                 '<option value="2">8-3/8" up to 8.5"</option>'+
                 '<option value="3">8-1/8" up to 8-1/4"</option>'+
                 '<option value="4">7-7/8" up to 8"</option>'+
                 '<option value="5" >7-5/8" up to 7-3/4"</option>'+
                 '<option value="6" >7-3/8" up to 7.5"</option>'+
                 '<option value="7" >7-1/8" up to 7-1/4"</option>'+
                 '<option value="8" >6-7/8" up to 7"</option>'+
                 '<option value="9" >6-5/8" up to 6-3/4"</option>'+
                 '<option value="10" >6-3/8" up to 6.5"</option>'+
                 '<option value="11" >6-1/8" up to 6-1/4"</option>'+
                 '<option value="12" >5-7/8" up to 6"</option>'+
                 '<option value="13" >5-5/8" up to 5-7/8"</option>'+
                 '<option value="14" >5-3/8" up to 5.5"</option>'+
                 '<option value="15" >5-1/8" up to 5-1/4"</option>'+
       "</select>"
   );
      
  }

}

  function goToPrintableSize(){
     window.open("https://www.mikoleon.com/pages/new-printable-size-chart", '_blank');
  }
